import * as ActionTypes from 'actions/Auth';

export default function reducer(
  state = {
    user: null,
    canCurrentUserCreateLicenses: undefined,
    parentOrg: null,
  },
  action
) {
  switch (action.type) {
    case ActionTypes.GET_TOKEN.FAILURE:
    case ActionTypes.LOGIN.FAILURE:
    case ActionTypes.LOGOUT.SUCCESS:
      return { user: null, canCurrentUserCreateLicenses: undefined };
    case ActionTypes.SET_CAN_CREATE_LICENSES:
      return { ...state, canCurrentUserCreateLicenses: action.payload };
    case ActionTypes.GET_TOKEN.SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case ActionTypes.GET_ROLE_MANAGEMENT_REPRESANTATION.SUCCESS:
      return {
        ...state,
        roleManagementRepresantation: action.payload,
      };
    case ActionTypes.SET_PARENT_ORG:
      return {
        ...state,
        parentOrg: action.payload,
      };
    default:
      return state;
  }
}
